.hours {
  display: flex;
  position: relative;
  height: var(--rc-calendar-hour-width);

  .time-slot {
    box-sizing: border-box;
    flex: 1;
    border-top: var(--rc-calendar-border-base);

    > .event-day {
      position: relative;
    }
  }

  .week-grid {
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    flex: 1;

    > div {
      box-sizing: border-box;
      border-right: var(--rc-calendar-border-base);

      &:last-child {
        border-right: 0;
      }
    }
  }
}

.slot {
  width: 100%;

  &:focus {
    background-color: var(--rc-calendar-color-primary-default);
  }
}
